import React, { useState } from "react";
import IncentiveModule from "./IncentiveDashboard/IncentiveModule";
import ItSetting from "./IncentiveDashboard/IncentiveSetting/ItSetting";
import NonItSetting from "./IncentiveDashboard/IncentiveSetting/NonItSetting";
import BenchSaleSetting from "./IncentiveDashboard/IncentiveSetting/BenchSaleSetting";
import { Modal, NewTab } from "../../../components";

const IncentiveDashboard = () => {
  const [showSettings, setShowSettings] = useState(false);
  const IncentiveMenus = [
    {
      title: "Incentive Module",
      page: <IncentiveModule />,
      type: "main",
    },
    {
      title: "Settings",
      icon: "settings",
      // page: <IncentiveModule />,
      type: "sub",
      action: () => setShowSettings(true),
    },
  ];

  const IncentiveSettingsMenu = [
    {
      title: "IT",
      page: <ItSetting onClose={() => setShowSettings(false)} />,
      type: "main",
    },
    {
      title: "Non-IT",
      page: <NonItSetting onClose={() => setShowSettings(false)} />,
      type: "main",
    },
    {
      title: "Benchsale",
      page: <BenchSaleSetting onClose={() => setShowSettings(false)} />,
      type: "main",
    },
  ];

  return (
    <div className="h-[calc(100vh-140px)] w-full flex flex-col gap-2 overflow-auto">
      <NewTab
        tabs={IncentiveMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="employee-management"
      />
      <Modal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
        title="Incentive Settings"
        width="max-w-7xl"
      >
        <div>
          <NewTab
            tabs={IncentiveSettingsMenu}
            color="black"
            variant="outlined"
          />
        </div>
      </Modal>
    </div>
  );
};

export default IncentiveDashboard;
